// @flow
import React from "react";
import Icon, { type IconProps } from "../";

export default function Cup({
  fill = "currentColor",
  width = "16px",
  ...props
}: IconProps) {
  return (
    <Icon viewBox="0 0 28 35" fill={fill} width={width} {...props}>
      <path
        d="M716.27 464h3.8v9.3h-1c-.6 0-1.13-.23-1.58-.7l-1.29-1.31c-.46-.4-.68-1.01-.68-1.63v-4.88c0-.47.3-.78.75-.78zm18.95 9.3V464H739c.45 0 .75.31.75.78v4.88c0 .62-.22 1.16-.68 1.63l-1.29 1.31c-.37.47-.98.7-1.59.7zm2.27 18.6c.38 0 .76-.4.76-.8v-1.59c0-.4-.38-.8-.76-.8h-.76v-3.78c0-.86-.68-1.56-1.51-1.56h-2.27v-.66c0-.5-.3-.82-.76-.82s-.76-.33-.76-.82v-2.56a5.31 5.31 0 0 0 3.57-3.66h1.2a3.4 3.4 0 0 0 2.65-1.16l1.3-1.32c.75-.7 1.13-1.7 1.13-2.71v-4.88c0-1.32-.99-2.33-2.27-2.33h-3.8v-1.43c.84 0 1.52-.72 1.52-1.61 0-.88-.68-1.61-1.51-1.61h-15.16c-.83 0-1.51.73-1.51 1.61 0 .89.68 1.61 1.51 1.61v1.43h-3.79c-1.28 0-2.27 1-2.27 2.33v4.88c0 1.08.38 2.01 1.14 2.71l1.29 1.32a3.52 3.52 0 0 0 2.65 1.16h1.2a5.32 5.32 0 0 0 3.57 3.66v2.56c0 .49-.3.82-.76.82-.45 0-.75.33-.75.82v.66h-2.28c-.83 0-1.51.7-1.51 1.56v3.78h-.76c-.38 0-.76.4-.76.8v1.6c0 .4.38.79.76.79z"
        transform="translate(-714 -457)"
      />
    </Icon>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Tournaments/Cup.js